"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function useToggleState(defaultValue = false) {
    const [value, setValue] = (0, react_1.useState)(defaultValue);
    const { enable, disable, toggle } = (0, react_1.useMemo)(() => ({
        enable: () => setValue(true),
        disable: () => setValue(false),
        toggle: () => setValue(prevValue => !prevValue),
    }), []);
    return [value, enable, disable, toggle];
}
exports.default = useToggleState;
//# sourceMappingURL=useToggleState.js.map